module.exports = __webpack_public_path__ + "static/media/level-toohard.d0f86d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/rating/img/level-toohard.png
// module id = 2091
// module chunks = 0